import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardCheckIcon, HomeIcon, MessageCircleIcon, CalendarCheckIcon, RefreshCwIcon, FrameIcon, GiftIcon } from 'lucide-react';
interface BonusSectionProps {
  onCtaClick: () => void;
}
export function BonusSection({
  onCtaClick
}: BonusSectionProps) {
  const bonuses = [{
    icon: ClipboardCheckIcon,
    title: 'Mapa Express de Puertas Abiertas',
    desc: 'Diagnóstico en 15 minutos. Sabés exactamente por dónde empezar sin leer todo primero.',
    value: '$5.000'
  }, {
    icon: HomeIcon,
    title: "Kit de Limpieza Física 'Casa en Orden = Vida en Orden'",
    desc: 'Checklist + guía práctica para ordenar tu espacio físico y sentir el cambio inmediato.',
    value: '$4.000'
  }, {
    icon: MessageCircleIcon,
    title: "Guión de Conversación 'Mi Familia No Cree'",
    desc: 'Cómo avanzar sin conflicto cuando tu entorno no acompaña. Frases exactas incluidas.',
    value: '$5.000'
  }, {
    icon: RefreshCwIcon,
    title: "Plan Anti-Retroceso '7 Días de Reset'",
    desc: 'Para cuando te caés. No reiniciás: retomás con un plan de 7 días que te devuelve el ritmo.',
    value: '$5.000'
  }, {
    icon: FrameIcon,
    title: "Pack de Carteles 'Declaraciones para el Hogar'",
    desc: 'Carteles digitales para tu hogar. Sostienen el clima y te recuerdan quién decidiste ser.',
    value: '$4.000'
  }];
  return <section className="py-12 md:py-32 px-4 bg-primary-bg relative" data-id="element-18">
      <div className="max-w-5xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-8 md:mb-16" data-id="element-20">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gold/10 border border-gold/30 text-gold font-bold text-xs md:text-sm tracking-wider mb-3 md:mb-4" data-id="element-21">
            <GiftIcon className="w-3.5 h-3.5" data-id="element-22" />
            INCLUIDO SIN COSTO EXTRA
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-2 md:mb-4" data-id="element-23">
            6 Bonos Que Recibís Hoy
          </h2>
          <p className="text-text-secondary font-body-serif text-base md:text-xl" data-id="element-24">
            Herramientas prácticas para que el sistema funcione en la vida real.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-6 mb-8 md:mb-16" data-id="element-25">
          {bonuses.map((bonus, idx) => {
          const Icon = bonus.icon;
          return <div key={idx} className="bg-card-bg rounded-xl md:rounded-2xl border border-border-gold shadow-sm p-4 md:p-6 relative overflow-hidden" data-id="element-26">
                {/* Value badge */}
                <div className="absolute top-3 right-3 md:top-4 md:right-4" data-id="element-27">
                  <span className="text-[10px] md:text-xs font-bold text-text-muted line-through bg-primary-bg px-2 py-0.5 rounded-full" data-id="element-28">
                    Valor {bonus.value}
                  </span>
                </div>

                <div className="flex items-start gap-3 md:gap-4" data-id="element-29">
                  <div className="w-10 h-10 md:w-12 md:h-12 shrink-0 rounded-xl bg-gold/10 flex items-center justify-center" data-id="element-30">
                    <Icon className="w-5 h-5 md:w-6 md:h-6 text-gold" data-id="element-31" />
                  </div>
                  <div className="min-w-0 pr-12 md:pr-16" data-id="element-32">
                    <h3 className="font-bold text-sm md:text-base text-text-primary mb-0.5 leading-snug" data-id="element-33">
                      <span className="text-gold font-bold mr-1" data-id="element-34">
                        BONO {idx + 1}:
                      </span>
                      {bonus.title}
                    </h3>
                    <p className="text-text-secondary text-xs md:text-sm leading-relaxed" data-id="element-35">
                      {bonus.desc}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {/* Total value callout */}
        <div className="text-center mb-6 md:mb-8" data-id="element-36">
          <p className="text-sm md:text-base text-text-secondary" data-id="element-37">
            Valor total de los 6 bonos:{' '}
            <span className="font-bold text-text-muted line-through" data-id="element-38">
              $29.000
            </span>{' '}
            →{' '}
            <span className="font-bold text-gold text-lg md:text-xl" data-id="element-39">
              GRATIS
            </span>
          </p>
        </div>

        <div className="flex justify-center" data-id="element-40">
          <button onClick={onCtaClick} className="btn-cta-pulse px-6 md:px-8 py-3.5 md:py-4 rounded-xl text-base md:text-lg tracking-wide w-full md:w-auto font-bold" data-id="element-41">
            QUIERO TODO ESTO HOY
          </button>
        </div>
      </div>
    </section>;
}